import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import { isMobileScreen, isWideScreen, urlSearchParams } from 'srcReact/helpers/utils'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import MessengerMobile from './MessengerMobile'
import MessengerDesktop from './MessengerDesktop'
import { useSelector, useDispatch } from 'react-redux'
import { messengerActions } from 'srcReact/MessengerPage/actions'
import { checkNested } from 'srcReact/helpers/validator'
import { alertActions, AlertContainer } from 'srcReact/Alert'
import useInterval from 'srcReact/helpers/hooks/useInterval'
import { messengerSettings } from 'srcReact/MessengerPage/MessengerSettings'

const MessengerPageContainer = (props) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    alert,
    common: { isNative, isMobile, isDesktop },
    organization: { current_organization },
    messenger: {
      organizationId,
      filterItem,
      conversation: { list }
    }
  } = useSelector((state) => state)
  // const [isMobile, setIsMobile] = useState(isMobileScreen())
  // const [isDesktop, setIsDesktop] = useState(isWideScreen())
  // const [isNative, setIsNative] = useState(isNativeScreen())
  const [isExpanded, setIsExpanded] = useState(true)

  // useEffect(() => {
  // window.addEventListener('change', handleWindowSizeChange)
  // nativeapp
  // if (isNative) {
  //   dispatch(messengerActions.setOrganizationId(urlSearchParams('organization_id')))
  //   dispatch(messengerActions.getConversationsList(urlSearchParams('organization_id'), filterItem))
  // }

  // return () => {
  //   window.removeEventListener('change', handleWindowSizeChange)
  // }
  // }, [])
  useEffect(() => {
    if (isNative) {
      dispatch(messengerActions.setOrganizationId(urlSearchParams('organization_id')))
      dispatch(messengerActions.getConversationsList(urlSearchParams('organization_id'), 1, filterItem))
      return
    }
    if (checkNested(current_organization, 'info', 'id')) {
      dispatch(messengerActions.setOrganizationId(current_organization.info.id))
      if (isDesktop) {
        dispatch(messengerActions.getConversationsList(current_organization.info.id, 1, filterItem, 1))
        // Set first conversation in desktop's conversation list as active
        if (list.length >= 1) {
          dispatch(messengerActions.getConversationOpen(list[0]?.conversation, list[0]?.conversation.id))
        }
        return
      }
      dispatch(messengerActions.getConversationsList(current_organization.info.id, 1, filterItem))
    }
  }, [current_organization && current_organization.info && current_organization.info.id, filterItem])
  // Get realtime updates
  useInterval(() => {
    if (organizationId > 0) {
      dispatch(messengerActions.getConversationsCheckUpdates(organizationId))
    }
  }, messengerSettings.REFRESH_INTERVAL)

  // const handleWindowSizeChange = () => {
  //   setIsNative(setIsNative())
  //   setIsMobile(isMobileScreen())
  //   setIsDesktop(isWideScreen())
  // }

  // if (isDesktop) {
  //   alert(isDesktop)
  // }

  return (
    <PageContainer
      pageClassName={`${styles.pageContainer} ${isNative && styles.isNative}`}
      pageTitle={t('messenger.title')}
      withFooter={false}>
      {alert && alert.message ? (
        <AlertContainer
          title={t('error.error_alert_title')}
          message={alert.message}
          show={!!alert.message}
          handleClose={() => dispatch(alertActions.clear())}
        />
      ) : null}
      {isDesktop ? (
        <MessengerDesktop
          isMobile={isMobile}
          isDesktop={isDesktop}
          isNative={isNative}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
        />
      ) : (
        <MessengerMobile
          isMobile={isMobile}
          isNative={isNative}
          isDesktop={isDesktop}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
        />
      )}
    </PageContainer>
  )
}

export { MessengerPageContainer }
